import Image1 from "./images/Allergy50.png";
import Image2 from "./images/AllergyPlus.png";
import Image3 from "./images/CoughandCold.png";
import Image4 from "./images/AmazonReceipt.png";
import Image5 from "./images/Initials.png";
import Image6 from "./images/InitialsFront.png";
import Image7 from "./images/Disposal.png";
import Image8 from "./images/DepositCenter.png";
import Image9 from "./images/Trashed.png";
import "../App.css";
import { useTranslation } from "react-i18next";
import { useState, useEffect, useRef, useMemo } from "react";
import * as bootstrap from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import RUG from "react-upload-gallery";
import axios from "axios";
import "./ThankYou";
import "./Error";
import { getEnv } from "../components/helpers/Config";
import { Axios } from "../axios/Axios";
import Viewer from "react-viewer";
import MaterialReactTable from "material-react-table";
import ReactGA from "react-ga";
import "react-upload-gallery/dist/style.css";
const TRACKING_ID = "UA-5168202-7";
ReactGA.initialize(TRACKING_ID);

export const Home = (props) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const location = useLocation();
  const fieldRef = useRef(null);
  const [showPage, setShowPage] = useState(1);
  const [isAvailable, setIsAvailable] = useState(false);
  const [ip, setIp] = useState(null);
  //This use effect checks to make sure the site is available then loads any data needed
  useEffect(() => {
    //creating function to load ip address from the API
    axios({
      method: "get",
      url: "https://api.ipify.org/?format=json",
    })
      .then((response) => {
        setIp(response.data.ip);

        axios({
          method: "get",
          url:
            url + "/verification/SiteAvailability?id=" + siteId + "&&ip=" + ip,
        })
          .then((response) => {
            if (!response.data) {
              navigate("/Construction", { replace: true });
            } else {
              document.getElementById("loading").classList.add("d-none");
              setIsAvailable(true);
            }
          })
          .catch((response) => {
            navigate("/Error", { replace: true });
          });
      })
      .catch((response) => {
        console.log("IP address retrieval failure");
      });
  }, []);
  //This useEffect is for google analytics
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  let navigate = useNavigate();
  const siteId = 57;
  let url = getEnv();
  const { t, i18n } = useTranslation();
  const {
    register,
    handleSubmit,
    getValues,
    watch,
    trigger,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onChange",
  });
  useEffect(() => {
    if (location.state?.data) {
      setShowPage(1);
      reset();
    }
  }, [location.key]);
  useEffect(() => {
    fieldRef.current.scrollIntoView({
      behavior: "smooth",
    });
  }, [showPage]);
  const onSubmit = (data) => {
    setIsSubmitting(true);
    const imagesArray = images.split(",");
    const images2Array = images2.split(",");
    const images3Array = images3.split(",");
    let SFDFI = [
      {
        DynamicFieldId: 33504,
        FieldValue: data.address,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33512,
        FieldValue: data.city,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33513,
        FieldValue: data.country,
        //FieldValue: "US",
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33508,
        FieldValue: data.email,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33502,
        FieldValue: data.firstName,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33503,
        FieldValue: data.lastName,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33515,
        FieldValue: data.postalCode,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 33507,
        FieldValue: data.phoneNumber,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      // Site Specific Fields
      {
        DynamicFieldId: 37611,
        FieldValue: "Refund",
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 67979,
        FieldValue: data.product,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 67983,
        FieldValue: refund,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 67980,
        FieldValue: imagesArray[1],
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 67981,
        FieldValue: images2Array[1],
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 67982,
        FieldValue: images3Array[1],
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
      {
        DynamicFieldId: 67998,
        FieldValue: ip,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      },
    ];
    if (data.country === "US") {
      SFDFI.push({
        DynamicFieldId: 33514,
        FieldValue: data.state,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    }
    if (data.country === "CA") {
      SFDFI.push({
        DynamicFieldId: 33539,
        FieldValue: data.province,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    }
    if (data.address2) {
      SFDFI.push({
        DynamicFieldId: 33506,
        FieldValue: data.address2,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    }
    if (data.confirm === "No") {
      SFDFI.push({
        DynamicFieldId: 60390,
        FieldValue: data.attentionTo,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    } else {
      SFDFI.push({
        DynamicFieldId: 60390,
        FieldValue: data.firstName + " " + data.lastName,
        Alias: "",
        InstanceID: 0,
        DynamicFieldInstanceID: 0,
      });
    }

    var SimpleSuperFormDTO = {
      FormInstances: {
        DefinitionId: 519,
        CompanyId: 109,
        CreatedBy: 803,
        CreatedFor: 803,
        WorkTypeItemId: 3655,
        WorkFlowOverallStatusId: 1,
        WorkflowId: 1,
        Source: 3,
        InstanceID: 0,
      },
      DynamicFieldslist: SFDFI,
    };
    SimpleSuperFormDTO.FormInstances.CreatedDate = new Date();
    console.log(SimpleSuperFormDTO);
    axios({
      method: "post",
      url: url + "/SuperForm/SaveSimpleSuperForm",
      data: SimpleSuperFormDTO,
    })
      .then((response) => {
        console.log("success");
        Axios.email(data, response.data.formInstances.instanceId, refund);
        navigate("/ThankYou", {
          state: {
            id: response.data.formInstances.instanceId,
            refund: refund,
          },
          replace: true,
        });
      })
      .catch((response) => {
        console.log("fail");
        navigate("/Error", { replace: true });
      });
  };
  console.log(errors);

  const [images, setImages] = useState([]);
  const [images2, setImages2] = useState([]);
  const [images3, setImages3] = useState([]);
  const [imageValid, setImageValid] = useState(true);
  const [image2Valid, setImage2Valid] = useState(true);
  const [image3Valid, setImage3Valid] = useState(true);

  const [addressValid, setAddressValid] = useState(true);
  const [byPassCheck, setByPassCheck] = useState(false);
  const [refund, setRefund] = useState(null);

  const [image1Visible, setImage1Visible] = useState(false);
  const [image2Visible, setImage2Visible] = useState(false);
  const [image3Visible, setImage3Visible] = useState(false);
  const [image4Visible, setImage4Visible] = useState(false);
  const [image5Visible, setImage5Visible] = useState(false);
  const [image6Visible, setImage6Visible] = useState(false);
  const [image7Visible, setImage7Visible] = useState(false);
  const [image8Visible, setImage8Visible] = useState(false);
  const [image9Visible, setImage9Visible] = useState(false);

  const watchConfirm = watch("confirm", null); // you can supply default value as second argument
  const watchCountry = watch("country", null); // you can supply default value as second argument
  //nested data is ok, see accessorKeys in ColumnDef below
  const data = [
    {
      itemNumber: i18n.t("step1.tableA1"),
      description: i18n.t("step1.tableB1"),
    },
    {
      itemNumber: i18n.t("step1.tableA2"),
      description: i18n.t("step1.tableB2"),
    },
    {
      itemNumber: i18n.t("step1.tableA3"),
      description: i18n.t("step1.tableB3"),
    },
    {
      itemNumber: i18n.t("step1.tableA4"),
      description: i18n.t("step1.tableB4"),
    },
  ];
  const columns = useMemo(
    () => [
      {
        accessorKey: "itemNumber", //access nested data with dot notation
        header: i18n.t("step1.tableA"),
      },
      {
        accessorKey: "description",
        header: i18n.t("step1.tableB"),
      },
    ],
    []
  );
  return (
    <div className="field" ref={fieldRef}>
      <bootstrap.Form onSubmit={handleSubmit(onSubmit)}>
        <bootstrap.Container fluid>
          <div
            className="spinner-grow text-primary text-center"
            id="loading"
          ></div>
          {isAvailable && (
            <div>
              {/* Start step 1 */}
              {showPage === 1 && (
                <div className="setup-content" id="step1">
                  <bootstrap.Row>
                    <bootstrap.Col>
                      <h2 className="py-1">{t("step1.header1")}</h2>
                      <p className="lead py-1">{t("step1.textA")}</p>
                      <p className="lead py-1">{t("step1.textB")}</p>
                      <p className="lead py-1">
                        {t("step1.textC")}{" "}
                        <a
                          className="lead"
                          href={t("layout.cpscLink")}
                          target="_blank"
                          return
                          false
                        >
                          {t("step1.textC1")}
                        </a>{" "}
                        {t("step1.textC2")}{" "}
                      </p>
                      <p className="lead py-1">{t("step1.textD")}</p>
                    </bootstrap.Col>
                  </bootstrap.Row>
                  <bootstrap.Row className="align-items-end">
                    <bootstrap.Col>
                      <bootstrap.Image
                        className="images img-fluid mx-auto d-block"
                        src={Image1}
                        onClick={() => {
                          setImage1Visible(true);
                        }}
                        id="allergy"
                        alt="Pysicians Care Allergy"
                      />
                      <Viewer
                        visible={image1Visible}
                        onClose={() => {
                          setImage1Visible(false);
                        }}
                        id="image1Viewer"
                        images={[
                          { src: Image1, alt: "Pysicians Care Allergy" },
                        ]}
                      ></Viewer>
                    </bootstrap.Col>
                    <bootstrap.Col>
                      <bootstrap.Image
                        className="images img-fluid mx-auto d-block"
                        src={Image2}
                        onClick={() => {
                          setImage2Visible(true);
                        }}
                        id="allergyPlus"
                        alt="Pysicians Care Allergy plus"
                      />
                      <Viewer
                        visible={image2Visible}
                        onClose={() => {
                          setImage2Visible(false);
                        }}
                        id="image2Viewer"
                        images={[
                          { src: Image3, alt: "Pysicians Care Allergy Plus" },
                        ]}
                      ></Viewer>
                    </bootstrap.Col>
                    <bootstrap.Col>
                      <bootstrap.Image
                        className="images img-fluid mx-auto d-block"
                        src={Image3}
                        onClick={() => {
                          setImage3Visible(true);
                        }}
                        id="coldCough"
                        alt="Pysicians Care Cold and Cough"
                      />
                      <Viewer
                        visible={image3Visible}
                        onClose={() => {
                          setImage3Visible(false);
                        }}
                        id="image3Viewer"
                        images={[
                          { src: Image3, alt: "Pysicians Care Cold and Cough" },
                        ]}
                      ></Viewer>
                    </bootstrap.Col>
                  </bootstrap.Row>
                  <bootstrap.Row className="py-3">
                    <bootstrap.Col>
                      <MaterialReactTable columns={columns} data={data} />
                    </bootstrap.Col>
                  </bootstrap.Row>

                  <bootstrap.Row>
                    <bootstrap.Col>
                      <p className="lead py-1">{t("step1.textE")}</p>
                      <p className="lead py-1">{t("step1.textF")}</p>
                      <p className="lead py-1">{t("step1.textG")}</p>
                      <p className="lead py-1">{t("step1.textH")}</p>
                      <ul>
                        <li className="lead py-1">{t("step1.textH1")}</li>
                        <li className="lead py-1">{t("step1.textH2")}</li>
                        <ul>
                          <li className="lead py-1">{t("step1.textH2A")}</li>
                        </ul>
                        <li className="lead py-1">{t("step1.textH3")}</li>
                        <ul>
                          <li className="lead py-1">
                            {t("step1.textH3A")}{" "}
                            <a
                              className="lead"
                              href={t("layout.disposalLink")}
                              target="_blank"
                              return
                              false
                            >
                              {t("step1.textH3A1")}
                            </a>
                          </li>
                        </ul>
                      </ul>
                      <p className="lead fw-bold py-1">{t("step1.textI")}</p>
                      <p className="lead py-1">{t("step1.textJ")}</p>
                    </bootstrap.Col>
                  </bootstrap.Row>
                  <bootstrap.Row className="text-center col align-content-lg-center py-2">
                    <bootstrap.Col>
                      <bootstrap.Button
                        className="btn btn-primary btn-lg"
                        type="button"
                        onClick={() => {
                          setShowPage(3);
                        }}
                        id="household"
                      >
                        {t("buttons.getStarted")}
                      </bootstrap.Button>
                    </bootstrap.Col>
                    <bootstrap.Col>
                      <bootstrap.Button
                        className="btn btn-primary btn-lg"
                        type="button"
                        onClick={() => {
                          setShowPage(2);
                        }}
                        id="office"
                      >
                        {t("buttons.continue")}
                      </bootstrap.Button>
                    </bootstrap.Col>
                  </bootstrap.Row>
                </div>
              )}
              {showPage === 2 && (
                <div className="setup-content" id="step2">
                  <bootstrap.Row>
                    <bootstrap.Col>
                      <p className="lead fw-bold pt-3">{t("step2.2A")}</p>
                    </bootstrap.Col>
                  </bootstrap.Row>
                </div>
              )}
              {/* Start step 3 */}
              {showPage === 3 && (
                <div className="setup-content" id="step2">
                  {/* Gather Contact Information */}
                  <bootstrap.Row>
                    <bootstrap.Col>
                      <h2 className="lead fw-bold py-3">
                        {t("contactStep.text")}
                      </h2>
                      <p className="lead py-2">{t("contactStep.textA")}</p>
                    </bootstrap.Col>
                  </bootstrap.Row>
                  <bootstrap.Row>
                    <bootstrap.Col>
                      <bootstrap.Card className="border-custom">
                        <bootstrap.Card.Body>
                          <bootstrap.Row>
                            <bootstrap.Col lg={2}></bootstrap.Col>
                            <bootstrap.Col className="form-group align-content-lg-center">
                              {/* First Name */}
                              <bootstrap.Form.Label
                                htmlFor="firstName"
                                className="lead"
                              >
                                {t("contactStep.firstName")}
                              </bootstrap.Form.Label>
                              <bootstrap.InputGroup className="mb-3">
                                <bootstrap.Form.Control
                                  type="text"
                                  // placeholder={t("contactStep.firstName")}
                                  id="firstName"
                                  {...register("firstName", {
                                    required: true,
                                    maxLength: 80,
                                  })}
                                />{" "}
                              </bootstrap.InputGroup>
                              {errors.firstName && (
                                <bootstrap.Alert variant="danger">
                                  <p className="lead text-danger text-center">
                                    {t("errors.required")}
                                  </p>
                                </bootstrap.Alert>
                              )}
                              {/* Last Name */}
                              <bootstrap.Form.Label
                                htmlFor="lastName"
                                className="lead"
                              >
                                {t("contactStep.lastName")}
                              </bootstrap.Form.Label>
                              <bootstrap.InputGroup className="mb-3">
                                <bootstrap.Form.Control
                                  type="text"
                                  //placeholder={t("contactStep.lastName")}
                                  id="lastName"
                                  {...register("lastName", {
                                    required: true,
                                    maxLength: 100,
                                  })}
                                />
                              </bootstrap.InputGroup>
                              {errors.lastName && (
                                <bootstrap.Alert variant="danger">
                                  <p className="lead text-danger text-center">
                                    {t("errors.required")}
                                  </p>
                                </bootstrap.Alert>
                              )}
                              {/* Email */}
                              <bootstrap.Form.Label
                                htmlFor="email"
                                className="lead"
                              >
                                {t("contactStep.email")}
                              </bootstrap.Form.Label>
                              <bootstrap.InputGroup className="mb-3">
                                <bootstrap.Form.Control
                                  type="email"
                                  //placeholder={t("contactStep.email")}
                                  id="email"
                                  aria-describedby="emailtext"
                                  {...register("email", {
                                    required: true,
                                    pattern:
                                      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                  })}
                                />

                                <bootstrap.InputGroup.Text id="emailText">
                                  @example.com
                                </bootstrap.InputGroup.Text>
                              </bootstrap.InputGroup>
                              {errors.email && (
                                <bootstrap.Alert variant="danger">
                                  <p className="lead text-danger text-center">
                                    {t("errors.required")}
                                  </p>
                                </bootstrap.Alert>
                              )}
                              {errors.email &&
                                errors.email.type === "pattern" && (
                                  <bootstrap.Alert variant="danger">
                                    <p className="lead text-danger text-center">
                                      {t("errors.emailFormatError")}
                                    </p>
                                  </bootstrap.Alert>
                                )}
                              {/* Verify Email */}
                              <bootstrap.Form.Label
                                htmlFor="verifyEmail"
                                className="lead"
                              >
                                {t("contactStep.verifyEmail")}
                              </bootstrap.Form.Label>
                              <bootstrap.InputGroup className="mb-3">
                                <bootstrap.Form.Control
                                  type="email"
                                  //placeholder={t("contactStep.verifyEmail")}
                                  id="verifyEmail"
                                  aria-describedby="verifyEmailText"
                                  {...register("verifyEmail", {
                                    required: true,
                                    pattern:
                                      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                    validate: {
                                      mismatch: (value) => {
                                        const { email } = getValues();
                                        return email === value;
                                      },
                                    },
                                  })}
                                />
                                <bootstrap.InputGroup.Text id="verifyEmailText">
                                  @example.com
                                </bootstrap.InputGroup.Text>
                              </bootstrap.InputGroup>
                              {errors.verifyEmail &&
                                errors.verifyEmail.type === "mismatch" && (
                                  <bootstrap.Alert variant="danger">
                                    <p className="lead text-danger text-center">
                                      {t("errors.emailMismatchError")}
                                    </p>
                                  </bootstrap.Alert>
                                )}
                              {errors.verifyEmail &&
                                errors.verifyEmail.type === "pattern" && (
                                  <bootstrap.Alert variant="danger">
                                    <p className="lead text-danger text-center">
                                      {t("errors.emailFormatError")}
                                    </p>
                                  </bootstrap.Alert>
                                )}
                              {errors.verifyEmail && (
                                <bootstrap.Alert variant="danger">
                                  <p className="lead text-danger text-center">
                                    {t("errors.required")}
                                  </p>
                                </bootstrap.Alert>
                              )}
                              {/* Phone */}
                              <bootstrap.Form.Label
                                htmlFor="phone"
                                className="lead"
                              >
                                {t("contactStep.phone")}
                              </bootstrap.Form.Label>
                              <bootstrap.InputGroup className="mb-3">
                                <bootstrap.Form.Control
                                  type="tel"
                                  placeholder="XXXXXXXXXX"
                                  id="phone"
                                  {...register("phoneNumber", {
                                    required: true,
                                    minLength: 10,
                                    pattern: /\d{10}/i,
                                  })}
                                />
                              </bootstrap.InputGroup>
                              {errors.phoneNumber && (
                                <bootstrap.Alert variant="danger">
                                  <p className="lead text-danger text-center">
                                    {t("errors.required")}
                                  </p>
                                </bootstrap.Alert>
                              )}
                              {errors.phoneNumber &&
                                errors.phoneNumber.type === "pattern" && (
                                  <bootstrap.Alert variant="danger">
                                    <p className="lead text-danger text-center">
                                      {t("errors.phoneFormatError")}
                                    </p>
                                  </bootstrap.Alert>
                                )}
                            </bootstrap.Col>
                            <bootstrap.Col lg={2}></bootstrap.Col>
                          </bootstrap.Row>
                          <bootstrap.Row>
                            <bootstrap.Col lg={2}></bootstrap.Col>
                            <bootstrap.Col className="py-1">
                              <p className="text-center lead font-weight-bold">
                                {t("contactStep.confirm")}
                              </p>
                              {/* Contact Confirm */}
                              <bootstrap.InputGroup className="mb-3">
                                <bootstrap.Form.Select
                                  className="text-center"
                                  aria-label="Default select example"
                                  id="confirm"
                                  {...register("confirm", { required: true })}
                                >
                                  <option value="">
                                    {t("layout.pleaseSelect")}
                                  </option>
                                  <option value="Yes">Yes</option>
                                  <option value="No">No</option>
                                </bootstrap.Form.Select>
                              </bootstrap.InputGroup>
                              {errors.confirm && (
                                <bootstrap.Alert variant="danger">
                                  <p className="lead text-danger text-center">
                                    {t("errors.required")}
                                  </p>
                                </bootstrap.Alert>
                              )}
                              {/* Attention To*/}
                              {watchConfirm === "No" && (
                                <div>
                                  <bootstrap.Form.Label
                                    htmlFor="attentionTo"
                                    className="lead"
                                  >
                                    {t("contactStep.attentionTo")}
                                  </bootstrap.Form.Label>
                                  <bootstrap.InputGroup className="mb-3">
                                    <bootstrap.Form.Control
                                      type="text"
                                      // placeholder={t("contactStep.firstName")}
                                      id="attentionTo"
                                      {...register("attentionTo", {
                                        maxLength: 80,
                                        validate: {
                                          required: (value) =>
                                            watchConfirm === "No" &&
                                            value.length > 0,
                                        },
                                      })}
                                    />
                                  </bootstrap.InputGroup>
                                  {errors.attentionTo && (
                                    <bootstrap.Alert variant="danger">
                                      <p className="lead text-danger text-center">
                                        {t("errors.required")}
                                      </p>
                                    </bootstrap.Alert>
                                  )}
                                </div>
                              )}
                            </bootstrap.Col>
                            <bootstrap.Col lg={2}></bootstrap.Col>
                          </bootstrap.Row>
                        </bootstrap.Card.Body>
                      </bootstrap.Card>
                    </bootstrap.Col>
                  </bootstrap.Row>
                  <div className="text-center col align-content-lg-center pt-3">
                    <bootstrap.Button
                      className="btn btn-primary btn-lg pt-1"
                      type="button"
                      onClick={async () => {
                        const result = await trigger([
                          "firstName",
                          "lastName",
                          "email",
                          "verifyEmail",
                          "phoneNumber",
                          "confirm",
                          "attentionTo",
                        ]);
                        if (result) {
                          setShowPage(4);
                        }
                      }}
                      id="step3Button"
                    >
                      {t("buttons.next")}
                    </bootstrap.Button>
                  </div>
                </div>
              )}
              {/* Start step 4 */}
              {showPage === 4 && (
                <div className="setup-content" id="step4">
                  {/* Gather Contact Information */}
                  <bootstrap.Row>
                    <bootstrap.Col>
                      <h2 className="py-3">{t("addressStep.header")}</h2>
                      <p className="lead py-2">{t("addressStep.subHeader")}</p>
                    </bootstrap.Col>
                  </bootstrap.Row>
                  <bootstrap.Row>
                    <bootstrap.Col>
                      <bootstrap.Card className="border-custom">
                        <bootstrap.Card.Body>
                          <bootstrap.Row>
                            <bootstrap.Col lg={2}></bootstrap.Col>
                            <bootstrap.Col className="form-group align-content-lg-center">
                              {/* Adress Line 1 */}
                              <bootstrap.Form.Label
                                htmlFor="address"
                                className="lead"
                              >
                                {t("addressStep.address1")}
                              </bootstrap.Form.Label>
                              <bootstrap.InputGroup className="mb-3">
                                <bootstrap.Form.Control
                                  type="text"
                                  id="address"
                                  {...register("address", { required: true })}
                                />
                              </bootstrap.InputGroup>
                              {errors.address && (
                                <bootstrap.Alert className="" variant="danger">
                                  <p className="lead text-danger text-center">
                                    {t("errors.required")}
                                  </p>
                                </bootstrap.Alert>
                              )}
                              {/* Address 2 */}
                              <bootstrap.Form.Label
                                htmlFor="address2"
                                className="lead"
                              >
                                {t("addressStep.address2")}
                              </bootstrap.Form.Label>
                              <bootstrap.InputGroup className="mb-3">
                                <bootstrap.Form.Control
                                  type="text"
                                  //placeholder={t("contactStep.lastName")}
                                  id="address2"
                                  {...register("address2", {})}
                                />
                              </bootstrap.InputGroup>
                              {errors.address2 && (
                                <bootstrap.Alert variant="danger">
                                  <p className="lead text-danger text-center">
                                    {t("errors.required")}
                                  </p>
                                </bootstrap.Alert>
                              )}
                              {/* City */}
                              <bootstrap.Form.Label
                                htmlFor="city"
                                className="lead"
                              >
                                {t("addressStep.city")}
                              </bootstrap.Form.Label>
                              <bootstrap.InputGroup className="mb-3">
                                <bootstrap.Form.Control
                                  type="text"
                                  //placeholder={t("contactStep.email")}
                                  id="city"
                                  {...register("city", { required: true })}
                                />
                              </bootstrap.InputGroup>
                              {errors.city && (
                                <bootstrap.Alert variant="danger">
                                  <p className="lead text-danger text-center">
                                    {t("errors.required")}
                                  </p>
                                </bootstrap.Alert>
                              )}
                              {/* Country */}
                              <bootstrap.Form.Label
                                htmlFor="country"
                                className="lead"
                              >
                                {t("addressStep.country")}
                              </bootstrap.Form.Label>
                              <bootstrap.InputGroup className="mb-3">
                                <bootstrap.Form.Select
                                  size="lg"
                                  className="text-center"
                                  //aria-label="Default select example"
                                  id="country"
                                  {...register("country", { required: true })}
                                >
                                  <option value="">
                                    {t("layout.pleaseSelect")}
                                  </option>
                                  <option value="US">United States</option>
                                  {/* <option value="CA">Canada</option> */}
                                </bootstrap.Form.Select>
                              </bootstrap.InputGroup>
                              {errors.country && (
                                <bootstrap.Alert variant="danger">
                                  <p className="lead text-danger text-center">
                                    {t("errors.required")}
                                  </p>
                                </bootstrap.Alert>
                              )}
                              {/* State */}
                              {watchCountry === "US" && (
                                <div>
                                  <bootstrap.Form.Label
                                    htmlFor="state"
                                    className="lead"
                                  >
                                    {t("addressStep.state")}
                                  </bootstrap.Form.Label>
                                  <bootstrap.InputGroup className="mb-3">
                                    <bootstrap.Form.Select
                                      size="lg"
                                      className="text-center"
                                      aria-label="Default State Label"
                                      id="state"
                                      {...register("state", { required: true })}
                                    >
                                      <option value="">
                                        {t("layout.pleaseSelect")}
                                      </option>
                                      <option value="AL">Alabama</option>
                                      <option value="AK">Alaska</option>
                                      <option value="AZ">Arizona</option>
                                      <option value="AR">Arkansas</option>
                                      <option value="CA">California</option>
                                      <option value="CO">Colorado</option>
                                      <option value="CT">Connecticut</option>
                                      <option value="DE">Delaware</option>
                                      <option value="DC">
                                        District of Columbia
                                      </option>
                                      <option value="FL">Florida</option>
                                      <option value="GA">Georgia</option>
                                      <option value="HI">Hawaii</option>
                                      <option value="ID">Idaho</option>
                                      <option value="IL">Illinois</option>
                                      <option value="IN">Indiana</option>
                                      <option value="IA">Iowa</option>
                                      <option value="KS">Kansas</option>
                                      <option value="KY">Kentucky</option>
                                      <option value="LA">Louisiana</option>
                                      <option value="ME">Maine</option>
                                      <option value="MD">Maryland</option>
                                      <option value="MA">Massachusetts</option>
                                      <option value="MI">Michigan</option>
                                      <option value="MN">Minnesota</option>
                                      <option value="MS">Mississippi</option>
                                      <option value="MO">Missouri</option>
                                      <option value="MT">Montana</option>
                                      <option value="NE">Nebraska</option>
                                      <option value="NV">Nevada</option>
                                      <option value="NH">New Hampshire</option>
                                      <option value="NJ">New Jersey</option>
                                      <option value="NM">New Mexico</option>
                                      <option value="NY">New York</option>
                                      <option value="NC">North Carolina</option>
                                      <option value="ND">North Dakota</option>
                                      <option value="OH">Ohio</option>
                                      <option value="OK">Oklahoma</option>
                                      <option value="OR">Oregon</option>
                                      <option value="PA">Pennsylvania</option>
                                      <option value="RI">Rhode Island</option>
                                      <option value="SC">South Carolina</option>
                                      <option value="SD">South Dakota</option>
                                      <option value="TN">Tennessee</option>
                                      <option value="TX">Texas</option>
                                      <option value="UT">Utah</option>
                                      <option value="VT">Vermont</option>
                                      <option value="VA">Virginia</option>
                                      <option value="WA">Washington</option>
                                      <option value="WV">West Virginia</option>
                                      <option value="WI">Wisconsin</option>
                                      <option value="WY">Wyoming</option>
                                      <option value="AA">
                                        Armed Forces Americas
                                      </option>
                                      <option value="AE">
                                        Armed Forces Canada
                                      </option>
                                      <option value="AP">
                                        Armed Forces Pacific
                                      </option>
                                      <option value="PR">Puerto Rico</option>
                                    </bootstrap.Form.Select>
                                  </bootstrap.InputGroup>
                                  {errors.state && (
                                    <bootstrap.Alert variant="danger">
                                      <p className="lead text-danger text-center">
                                        {t("errors.required")}
                                      </p>
                                    </bootstrap.Alert>
                                  )}
                                </div>
                              )}
                              {watchCountry === "CA" && (
                                <div>
                                  <bootstrap.Form.Label
                                    htmlFor="province"
                                    className="lead"
                                  >
                                    {t("addressStep.province")}
                                  </bootstrap.Form.Label>
                                  <bootstrap.InputGroup className="mb-3">
                                    <bootstrap.Form.Select
                                      size="lg"
                                      className="text-center"
                                      aria-label="Default State Label"
                                      id="province"
                                      {...register("province", {
                                        required: true,
                                      })}
                                    >
                                      <option value="">
                                        {t("layout.pleaseSelect")}
                                      </option>
                                      <option value="AB">Alberta</option>
                                      <option value="BC">
                                        British Columbia
                                      </option>
                                      <option value="MB">Manitoba</option>
                                      <option value="NB">New Brunswick</option>
                                      <option value="NL">
                                        Newfoundland and Labrador
                                      </option>
                                      <option value="NT">
                                        Northwest Territories
                                      </option>
                                      <option value="NS">Nova Scotia</option>
                                      <option value="NU">Nunavut</option>
                                      <option value="ON">Ontario</option>
                                      <option value="PE">
                                        Prince Edward Island
                                      </option>
                                      <option value="QC">Quebec</option>
                                      <option value="SK">Saskatchewan</option>
                                      <option value="YT">Yukon</option>
                                    </bootstrap.Form.Select>
                                  </bootstrap.InputGroup>
                                  {errors.state && (
                                    <bootstrap.Alert variant="danger">
                                      <p className="lead text-danger text-center">
                                        {t("errors.required")}
                                      </p>
                                    </bootstrap.Alert>
                                  )}
                                </div>
                              )}

                              {/* Postal */}
                              <bootstrap.Form.Label
                                htmlFor="postal"
                                className="lead"
                              >
                                {t("addressStep.postalCode")}
                              </bootstrap.Form.Label>
                              <bootstrap.InputGroup className="mb-3">
                                <bootstrap.Form.Control
                                  type="text"
                                  //placeholder="XXXXXXXXXX"
                                  id="postal"
                                  {...register("postalCode", {
                                    required: true,
                                    min: 5,
                                    pattern:
                                      /\d{5}(-\d{4})?/i |
                                      /^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z][ -]?[0-9][ABCEGHJ-NPRSTV-Z][0-9]$/i,
                                  })}
                                />
                              </bootstrap.InputGroup>
                              {errors.postalCode && (
                                <bootstrap.Alert variant="danger">
                                  <p className="lead text-danger text-center">
                                    {t("errors.required")}
                                  </p>
                                </bootstrap.Alert>
                              )}
                            </bootstrap.Col>
                            <bootstrap.Col lg={2}></bootstrap.Col>
                          </bootstrap.Row>
                        </bootstrap.Card.Body>
                      </bootstrap.Card>
                    </bootstrap.Col>
                  </bootstrap.Row>
                  {!addressValid && (
                    <bootstrap.Alert variant="danger" className="pt-3">
                      {/* Address Bypass*/}
                      <bootstrap.Form.Check
                        type="checkbox"
                        id="bypassCheck"
                        onChange={(e) => {
                          if (e.target.checked) {
                            setByPassCheck(true);
                          } else {
                            setByPassCheck(false);
                          }
                        }}
                      >
                        <bootstrap.Form.Check.Input type="checkbox" />
                        <bootstrap.Form.Check.Label className="lead text-danger text-center">
                          {t("errors.addressError")}
                        </bootstrap.Form.Check.Label>
                      </bootstrap.Form.Check>
                    </bootstrap.Alert>
                  )}
                  <div className="text-center col align-content-lg-center pt-3">
                    <bootstrap.Button
                      className="btn btn-primary btn-lg pt-1"
                      type="button"
                      id="page5Button"
                      onClick={async () => {
                        const result = await trigger([
                          "address",
                          "city",
                          "country",
                          "state",
                          "postalCode",
                        ]);
                        if (result) {
                          if (
                            addressValid &&
                            !byPassCheck &&
                            watchCountry === "US"
                          ) {
                            var person = {
                              Name:
                                getValues("firstName") +
                                " " +
                                getValues("lastName"),
                              Address: getValues("address"),
                              Address2: getValues("address2"),
                              City: getValues("city"),
                              State: getValues("state"),
                              Country: "US",
                              PostalCode: getValues("postalCode"),
                            };
                            axios({
                              method: "post",
                              url: url + "/Verification/Address",
                              data: person,
                            })
                              .then((data) => {
                                if (
                                  data.data[0].responseMessage ===
                                  "Invalid UPS Shipping Address."
                                ) {
                                  setAddressValid(false);
                                } else {
                                  setValue("address", data.data[0].address);
                                  setValue("address2", data.data[0].address2);
                                  setValue("city", data.data[0].city);
                                  setValue("state", data.data[0].state);
                                  setValue(
                                    "postalCode",
                                    data.data[0].postalCode
                                  );
                                  setAddressValid(true);
                                  setShowPage(5);
                                }
                              })
                              .catch((data) => {
                                setAddressValid(false);
                              });
                          } else {
                            setShowPage(5);
                          }
                        }
                      }}
                    >
                      {t("buttons.next")}
                    </bootstrap.Button>
                  </div>
                </div>
              )}
              {/* Start step 5 */}
              {showPage === 5 && (
                <div className="setup-content" id="step5">
                  <bootstrap.Container className="py-2">
                    <bootstrap.Card className="border-custom">
                      <bootstrap.Card.Body>
                        <bootstrap.Row>
                          <bootstrap.Col>
                            <h2 className="lead fw-bold py-1">
                              {t("step5.header")}
                            </h2>
                            <p className="lead py-1">{t("step5.5A")}</p>
                          </bootstrap.Col>
                        </bootstrap.Row>
                        <bootstrap.Row>
                          <bootstrap.Col lg={2}></bootstrap.Col>
                          <bootstrap.Col className="form-group align-content-lg-center">
                            {/* Product Choice */}
                            <bootstrap.InputGroup className="mb-3">
                              <bootstrap.Form.Select
                                size="lg"
                                className="text-center"
                                //aria-label="Default select example"
                                id="product"
                                {...register("product", { required: true })}
                              >
                                <option value="">
                                  {t("layout.pleaseSelect")}
                                </option>
                                <option value={t("step5.option1")}>
                                  {t("step5.option1")}
                                </option>
                                <option value={t("step5.option2")}>
                                  {t("step5.option2")}
                                </option>
                                <option value={t("step5.option3")}>
                                  {t("step5.option3")}
                                </option>
                                <option value={t("step5.option4")}>
                                  {t("step5.option4")}
                                </option>
                              </bootstrap.Form.Select>
                            </bootstrap.InputGroup>
                            {errors.product && (
                              <bootstrap.Alert variant="danger">
                                <p className="lead text-danger text-center">
                                  {t("errors.required")}
                                </p>
                              </bootstrap.Alert>
                            )}
                          </bootstrap.Col>
                          <bootstrap.Col lg={2}></bootstrap.Col>
                        </bootstrap.Row>
                        <bootstrap.Row className="text-center col align-content-lg-center pt-3">
                          <bootstrap.Col>
                            <bootstrap.Button
                              className="btn btn-primary btn-lg pt-1"
                              type="button"
                              onClick={async () => {
                                const result = await trigger(["product"]);
                                if (result) {
                                  var value = getValues("product");
                                  if (value.includes("90036")) {
                                    setRefund("5.25");
                                  } else if (value.includes("90091")) {
                                    setRefund("7.79");
                                  } else if (value.includes("90092")) {
                                    setRefund("7.50");
                                  } else if (value.includes("90033")) {
                                    setRefund("18.33");
                                  }
                                  setShowPage(6);
                                }
                              }}
                              id="step5Button"
                            >
                              {t("buttons.next")}
                            </bootstrap.Button>
                          </bootstrap.Col>
                        </bootstrap.Row>
                      </bootstrap.Card.Body>
                    </bootstrap.Card>
                  </bootstrap.Container>
                </div>
              )}
              {/* Start step 6 */}
              {showPage === 6 && (
                <div className="setup-content" id="step6">
                  <bootstrap.Row>
                    <bootstrap.Col>
                      <h2 className="py-2">{t("step6.header")}</h2>
                      <p className="lead">{t("step6.6A")}</p>
                      <p className="lead">{t("step6.6B")}</p>
                      <p className="lead">{t("step6.6C")}</p>
                    </bootstrap.Col>
                  </bootstrap.Row>

                  <bootstrap.Row className="align-items-end">
                    <bootstrap.Col></bootstrap.Col>
                    <bootstrap.Col>
                      <bootstrap.Image
                        className="images img-fluid"
                        src={Image4}
                        onClick={() => {
                          setImage4Visible(true);
                        }}
                        id="image4"
                        alt="Amazon Receipt"
                      />
                      <Viewer
                        visible={image4Visible}
                        onClose={() => {
                          setImage4Visible(false);
                        }}
                        id="image4Viewer"
                        images={[{ src: Image4, alt: "Amazon Receipt" }]}
                      ></Viewer>
                    </bootstrap.Col>
                    <bootstrap.Col></bootstrap.Col>
                  </bootstrap.Row>

                  {/* Photo Upload */}
                  <bootstrap.Row className="pt-5">
                    <bootstrap.Col lg={2}></bootstrap.Col>
                    <bootstrap.Col className="py-1">
                      <RUG
                        rules={{
                          limit: 1,
                          size: 5000,
                        }}
                        accept={["jpg", "jpeg", "png", "gif"]}
                        onWarning={(type, rules) => {
                          switch (type) {
                            case "accept":
                              return window.confirm(
                                `Invalid file type. Acceptable photo formats include ${rules.accept.join(
                                  ","
                                )}`
                              );
                            case "limit":
                              return window.confirm(
                                `Only ${rules.limit} image allowed to be uploaded`
                              );

                            case "size":
                              return window.confirm(
                                `max size <= ${rules.size} KB`
                              );

                            default:
                          }
                        }}
                        // onConfirmDelete={(currentImage, images) => {
                        //   setImages([]);
                        // }}
                        onChange={(images) => {
                          if (images.length === 0) {
                            setImages(images);
                          }
                        }}
                        customRequest={({
                          uid,
                          file,
                          data, // blob
                          send,
                          action,
                          headers,
                          onProgress,
                          onSuccess,
                          onError,
                        }) => {
                          if (file) {
                            let reader = new FileReader();
                            reader.readAsDataURL(file);
                            reader.onload = (e) => {
                              setImages(reader.result);
                            };
                            setImageValid(true);
                          } else {
                            setImageValid(false);
                          }
                          return {
                            abort() {
                              // for cancels the request
                            },
                          };
                        }}
                      />
                      <p className="lead">{t("step6.6D")}</p>
                      {!imageValid && (
                        <bootstrap.Alert variant="danger">
                          <p className="lead text-danger text-center">
                            {t("errors.required")}
                          </p>
                        </bootstrap.Alert>
                      )}
                    </bootstrap.Col>
                    <bootstrap.Col lg={2}></bootstrap.Col>
                  </bootstrap.Row>
                  <bootstrap.Row className="text-center col align-content-lg-center pt-3">
                    <bootstrap.Col>
                      <bootstrap.Button
                        className="btn btn-primary btn-lg pt-1"
                        type="button"
                        onClick={() => {
                          if (images.length > 0) {
                            setImageValid(true);
                            setShowPage(7);
                          } else {
                            setImageValid(false);
                          }
                        }}
                        id="step6Button"
                      >
                        {t("buttons.next")}
                      </bootstrap.Button>
                    </bootstrap.Col>
                  </bootstrap.Row>
                </div>
              )}
              {/* Start step 7 */}
              {showPage === 7 && (
                <div className="setup-content" id="step7">
                  <bootstrap.Row>
                    <bootstrap.Col>
                      <h2 className="py-2">{t("step7.header")}</h2>
                      <p className="lead">{t("step7.7A")}</p>
                      <p className="lead">{t("step7.7B")}</p>
                    </bootstrap.Col>
                  </bootstrap.Row>
                  <bootstrap.Row className="align-items-end">
                    <bootstrap.Col lg={4}></bootstrap.Col>
                    <bootstrap.Col>
                      <bootstrap.Image
                        className="images img-fluid"
                        src={Image5}
                        onClick={() => {
                          setImage5Visible(true);
                        }}
                        id="image5"
                        alt="Allergy Plus w/ Initials"
                      />
                      <Viewer
                        visible={image5Visible}
                        onClose={() => {
                          setImage5Visible(false);
                        }}
                        id="image5Viewer"
                        images={[
                          { src: Image5, alt: "Allergy Plus w/ Initials" },
                        ]}
                      ></Viewer>
                    </bootstrap.Col>
                    <bootstrap.Col>
                      <bootstrap.Image
                        className="images img-fluid"
                        src={Image6}
                        onClick={() => {
                          setImage6Visible(true);
                        }}
                        id="image6"
                        alt="Initials"
                      />
                      <Viewer
                        visible={image6Visible}
                        onClose={() => {
                          setImage6Visible(false);
                        }}
                        id="image6Viewer"
                        images={[{ src: Image6, alt: "Initials" }]}
                      ></Viewer>
                    </bootstrap.Col>
                    <bootstrap.Col lg={4}></bootstrap.Col>
                  </bootstrap.Row>

                  {/* Photo Upload */}
                  <bootstrap.Row className="pt-5">
                    <bootstrap.Col lg={2}></bootstrap.Col>
                    <bootstrap.Col className="py-1">
                      <RUG
                        rules={{
                          limit: 1,
                          size: 5000,
                        }}
                        accept={["jpg", "jpeg", "png", "gif"]}
                        onWarning={(type, rules) => {
                          switch (type) {
                            case "accept":
                              return window.confirm(
                                `Invalid file type. Acceptable photo formats include ${rules.accept.join(
                                  ","
                                )}`
                              );
                            case "limit":
                              return window.confirm(
                                `Only ${rules.limit} image allowed to be uploaded`
                              );

                            case "size":
                              return window.confirm(
                                `max size <= ${rules.size} KB`
                              );

                            default:
                          }
                        }}
                        onChange={(images) => {
                          if (images.length === 0) {
                            setImages2(images);
                          }
                        }}
                        customRequest={({
                          uid,
                          file,
                          data, // blob
                          send,
                          action,
                          headers,
                          onProgress,
                          onSuccess,
                          onError,
                        }) => {
                          if (file) {
                            let reader = new FileReader();
                            reader.readAsDataURL(file);
                            reader.onload = (e) => {
                              setImages2(reader.result);
                            };
                            setImage2Valid(true);
                          } else {
                            setImage2Valid(false);
                          }
                          return {
                            abort() {
                              // for cancels the request
                            },
                          };
                        }}
                      />
                      <p className="lead">{t("step7.7C")}</p>
                      {!image2Valid && (
                        <bootstrap.Alert variant="danger">
                          <p className="lead text-danger text-center">
                            {t("errors.required")}
                          </p>
                        </bootstrap.Alert>
                      )}
                    </bootstrap.Col>
                    <bootstrap.Col lg={2}></bootstrap.Col>
                  </bootstrap.Row>
                  <bootstrap.Row className="text-center col align-content-lg-center pt-3">
                    <bootstrap.Col>
                      <bootstrap.Button
                        className="btn btn-primary btn-lg pt-1"
                        type="button"
                        onClick={() => {
                          if (images2.length > 0) {
                            setImage2Valid(true);
                            setShowPage(8);
                          } else {
                            setImage2Valid(false);
                          }
                        }}
                        id="step7Button"
                      >
                        {t("buttons.next")}
                      </bootstrap.Button>
                    </bootstrap.Col>
                  </bootstrap.Row>
                </div>
              )}
              {/* Start step 8 */}
              {showPage === 8 && (
                <div className="setup-content" id="step8">
                  <bootstrap.Row>
                    <bootstrap.Col>
                      <h2 className="py-2">{t("step8.header")}</h2>
                      <p className="lead">{t("step8.8A")}</p>
                      <p className="lead">{t("step8.8B")}</p>
                      <ul>
                        <li className="lead py-1">{t("step8.8B1")}</li>
                        <li className="lead py-1">{t("step8.8B2")}</li>
                      </ul>
                    </bootstrap.Col>
                  </bootstrap.Row>
                  <bootstrap.Row className="align-items-end">
                    <bootstrap.Col lg={4}></bootstrap.Col>
                    <bootstrap.Col>
                      <bootstrap.Image
                        className="images img-fluid"
                        src={Image7}
                        onClick={() => {
                          setImage7Visible(true);
                        }}
                        id="image7"
                        alt="Disposal"
                      />
                      <Viewer
                        visible={image7Visible}
                        onClose={() => {
                          setImage7Visible(false);
                        }}
                        id="image7Viewer"
                        images={[{ src: Image7, alt: "Disposal" }]}
                      ></Viewer>
                    </bootstrap.Col>
                    <bootstrap.Col>
                      <bootstrap.Image
                        className="images img-fluid"
                        src={Image8}
                        onClick={() => {
                          setImage8Visible(true);
                        }}
                        id="image8"
                        alt="Disposal Center"
                      />
                      <Viewer
                        visible={image8Visible}
                        onClose={() => {
                          setImage8Visible(false);
                        }}
                        id="image8Viewer"
                        images={[{ src: Image8, alt: "Disposal Center" }]}
                      ></Viewer>
                    </bootstrap.Col>
                    <bootstrap.Col lg={4}></bootstrap.Col>
                  </bootstrap.Row>
                  <bootstrap.Row>
                    <bootstrap.Col>
                      <p className="lead fw-bold">{t("step8.8C")}</p>
                      <p className="lead">{t("step8.8D")}</p>
                      <ul>
                        <li className="lead py-1">{t("step8.8D1")}</li>
                      </ul>
                    </bootstrap.Col>
                  </bootstrap.Row>
                  <bootstrap.Row className="align-items-end">
                    <bootstrap.Col></bootstrap.Col>
                    <bootstrap.Col>
                      <bootstrap.Image
                        className="images img-fluid"
                        src={Image9}
                        onClick={() => {
                          setImage9Visible(true);
                        }}
                        id="image9"
                        alt="Improper Disposal"
                      />
                      <Viewer
                        visible={image9Visible}
                        onClose={() => {
                          setImage9Visible(false);
                        }}
                        id="image9Viewer"
                        images={[{ src: Image9, alt: "Improper Disposal" }]}
                      ></Viewer>
                    </bootstrap.Col>
                    <bootstrap.Col></bootstrap.Col>
                  </bootstrap.Row>
                  <bootstrap.Row>
                    <bootstrap.Col>
                      <p className="lead">{t("step8.8E")}</p>
                    </bootstrap.Col>
                  </bootstrap.Row>
                  {/* Photo Upload */}
                  <bootstrap.Row className="pt-5">
                    <bootstrap.Col lg={2}></bootstrap.Col>
                    <bootstrap.Col className="py-1">
                      <RUG
                        rules={{
                          limit: 1,
                          size: 5000,
                        }}
                        accept={["jpg", "jpeg", "png", "gif"]}
                        onWarning={(type, rules) => {
                          switch (type) {
                            case "accept":
                              return window.confirm(
                                `Invalid file type. Acceptable photo formats include ${rules.accept.join(
                                  ","
                                )}`
                              );
                            case "limit":
                              return window.confirm(
                                `Only ${rules.limit} image allowed to be uploaded`
                              );

                            case "size":
                              return window.confirm(
                                `max size <= ${rules.size} KB`
                              );

                            default:
                          }
                        }}
                        onChange={(images) => {
                          if (images.length === 0) {
                            setImages3(images);
                          }
                        }}
                        customRequest={({
                          uid,
                          file,
                          data, // blob
                          send,
                          action,
                          headers,
                          onProgress,
                          onSuccess,
                          onError,
                        }) => {
                          if (file) {
                            let reader = new FileReader();
                            reader.readAsDataURL(file);
                            reader.onload = (e) => {
                              setImages3(reader.result);
                            };
                            setImage3Valid(true);
                          } else {
                            setImage3Valid(false);
                          }
                          return {
                            abort() {
                              // for cancels the request
                            },
                          };
                        }}
                      />
                      {!image3Valid && (
                        <bootstrap.Alert variant="danger">
                          <p className="lead text-danger text-center">
                            {t("errors.required")}
                          </p>
                        </bootstrap.Alert>
                      )}
                    </bootstrap.Col>
                    <bootstrap.Col lg={2}></bootstrap.Col>
                  </bootstrap.Row>
                  <bootstrap.Row className="text-center col align-content-lg-center pt-3">
                    <bootstrap.Col>
                      <bootstrap.Button
                        className="btn btn-primary btn-lg pt-1"
                        type="button"
                        onClick={() => {
                          if (images3.length > 0) {
                            setImage3Valid(true);
                            setShowPage(9);
                          } else {
                            setImage3Valid(false);
                          }
                        }}
                        id="step8Button"
                      >
                        {t("buttons.next")}
                      </bootstrap.Button>
                    </bootstrap.Col>
                  </bootstrap.Row>
                </div>
              )}
              {/* Start step 9 */}
              {showPage === 9 && (
                <div className="setup-content" id="step9">
                  <bootstrap.Row>
                    <bootstrap.Col>
                      <h2 className="py-2">{t("step9.header")}</h2>
                      <p className="lead">{t("step9.9A")}</p>
                      <p className="lead">{t("step9.9B")}</p>
                      <p className="lead">
                        {t("step9.9C")}
                        {refund} {t("step9.9C1")}
                      </p>
                    </bootstrap.Col>
                  </bootstrap.Row>
                  <bootstrap.Row className="pt-2">
                    {!isSubmitting && (
                      <bootstrap.Button
                        className="btn btn-primary btn-lg pt-1 justify-content-center"
                        type="submit"
                        id="SubmitButton"
                      >
                        {t("buttons.submit")}
                      </bootstrap.Button>
                    )}
                    {isSubmitting && (
                      <bootstrap.Button
                        className="btn btn-primary btn-lg pt-1 justify-content-center"
                        variant="primary"
                        disabled
                      >
                        <bootstrap.Spinner
                          as="span"
                          animation="border"
                          variant="status"
                          aria-hidden="true"
                        ></bootstrap.Spinner>
                      </bootstrap.Button>
                    )}
                  </bootstrap.Row>
                </div>
              )}
            </div>
          )}
        </bootstrap.Container>
      </bootstrap.Form>
    </div>
  );
};
